// The redaction editor's API contract shared by the server (trigger + 4xx bodies)
// and the client (dialog scope count, skip-entry copy): which category statuses
// can be edited, and the machine-readable reasons an EDIT_REDACTIONS trigger
// refuses / skips a category with (`code` on the 4xx body and on the
// `skipped[]` entries of "Redact all occurrences"). One definition — a new
// code or a new editable status is added here, never mirrored by hand.

/** Categories whose redactions can be edited (REDACTIONS_FINALIZED rolls back to NOTED on save). */
export const EDITABLE_CATEGORY_STATUSES = ['REDACTIONS_NOTED', 'REDACTIONS_FINALIZED']

export const REDACTION_OCCURRENCE_ACTION = {
  REDACT: 'redact',
  UNREDACT: 'unredact'
}

export const REDACTION_OCCURRENCE_ACTIONS = Object.values(REDACTION_OCCURRENCE_ACTION)

export const EDIT_REDACTIONS_SKIP_CODES = {
  NOT_AT_REDACTION_STAGE: 'NOT_AT_REDACTION_STAGE', // + status
  NO_NOTED_FILE: 'NO_NOTED_FILE',
  MULTIPLE_NOTED_FILES: 'MULTIPLE_NOTED_FILES',
  PENDING_WORKFLOW: 'PENDING_WORKFLOW', // + workflowType
  STALE_VERSION: 'STALE_VERSION' // + currentVersion
}
